// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dpg-form-container {
    background: #e3f0f7;
    border: 1px solid #577481;
    border-radius: 6px;
    padding: 1rem;
}

.dpg-new-entry {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 1rem;
}

    .dpg-new-entry input[type="text"],
    .dpg-new-entry input[type="number"] {
        flex: 1 1 140px;
        padding: 6px;
        border-radius: 5px;
        border: 1px solid #ccc;
    }

    .dpg-new-entry label {
        display: flex;
        align-items: center;
        gap: 4px;
        font-weight: 600;
    }

    .dpg-new-entry button {
        padding: 8px 12px;
        background: #0061b0;
        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        flex: 1 1 120px;
    }

.dpg-table {
    width: 100%;
    border-collapse: collapse;
}

    .dpg-table th,
    .dpg-table td {
        border: 1px solid #577481;
        padding: 8px;
        text-align: left;
    }

    .dpg-table th {
        background-color: #577481;
        color: white;
    }

.dpg-actions {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

    .dpg-actions button {
        padding: 8px 16px;
        border-radius: 5px;
        border: none;
        cursor: pointer;
        font-weight: 600;
    }

        .dpg-actions button.danger {
            background-color: #dc3545;
            color: white;
        }

        .dpg-actions button:not(.danger) {
            background-color: #0061b0;
            color: white;
        }
`, "",{"version":3,"sources":["webpack://./src/pages/demo/forms/DPGForm.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;IAEI;;QAEI,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,eAAe;IACnB;;AAEJ;IACI,WAAW;IACX,yBAAyB;AAC7B;;IAEI;;QAEI,yBAAyB;QACzB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,YAAY;IAChB;;AAEJ;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;IAEI;QACI,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;;QAEI;YACI,yBAAyB;YACzB,YAAY;QAChB;;QAEA;YACI,yBAAyB;YACzB,YAAY;QAChB","sourcesContent":[".dpg-form-container {\n    background: #e3f0f7;\n    border: 1px solid #577481;\n    border-radius: 6px;\n    padding: 1rem;\n}\n\n.dpg-new-entry {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 1rem;\n}\n\n    .dpg-new-entry input[type=\"text\"],\n    .dpg-new-entry input[type=\"number\"] {\n        flex: 1 1 140px;\n        padding: 6px;\n        border-radius: 5px;\n        border: 1px solid #ccc;\n    }\n\n    .dpg-new-entry label {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        font-weight: 600;\n    }\n\n    .dpg-new-entry button {\n        padding: 8px 12px;\n        background: #0061b0;\n        color: white;\n        border: none;\n        border-radius: 5px;\n        cursor: pointer;\n        flex: 1 1 120px;\n    }\n\n.dpg-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n    .dpg-table th,\n    .dpg-table td {\n        border: 1px solid #577481;\n        padding: 8px;\n        text-align: left;\n    }\n\n    .dpg-table th {\n        background-color: #577481;\n        color: white;\n    }\n\n.dpg-actions {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n}\n\n    .dpg-actions button {\n        padding: 8px 16px;\n        border-radius: 5px;\n        border: none;\n        cursor: pointer;\n        font-weight: 600;\n    }\n\n        .dpg-actions button.danger {\n            background-color: #dc3545;\n            color: white;\n        }\n\n        .dpg-actions button:not(.danger) {\n            background-color: #0061b0;\n            color: white;\n        }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
